import { useCallback, useMemo } from 'react'

import { LocalStorageKeys, useLocalStorage } from '@/lib/storage/local-storage.hook'

// Per-company set of IRQ groups the user has navigated past, persisted across modal reopens.
export const useIrqValidatedSet = (companyId: string) => {
  const [byCompany, setByCompany] = useLocalStorage(LocalStorageKeys.irqValidated)

  const set = useMemo(() => new Set(byCompany?.[companyId] ?? []), [byCompany, companyId])

  const markValidated = useCallback(
    (id: string) => {
      if (set.has(id)) return
      const next = new Set(set).add(id)
      setByCompany({ ...byCompany, [companyId]: [...next] })
    },
    [set, byCompany, companyId, setByCompany],
  )

  const clear = useCallback(() => {
    if (!byCompany || !(companyId in byCompany)) return
    const { [companyId]: _removed, ...rest } = byCompany
    setByCompany(rest)
  }, [byCompany, companyId, setByCompany])

  return { set, markValidated, clear }
}
